import { User } from '@gcv/shared';

export function isGcvCustomerSupportUserAndNeedsToSignIn(user: User): boolean {
  return user.role === 'gcv_customer_support' && user.initial_user;
}
